import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Seo/headings.css';
import './Seo/wow-prerender.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { store } from './app/store';
import { Provider } from 'react-redux';
import { ToastContainer } from "react-toastify";
import "./i18n";
import { HelmetProvider } from "react-helmet-async";

const container = document.getElementById('root');

const tree = (
  <BrowserRouter>
    <Provider store={store}>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="light"
      />
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Provider>
  </BrowserRouter>
);

/**
 * Prerendered routes ship real markup inside #root, so we hydrate it rather
 * than throw it away — that keeps the already-painted content on screen
 * instead of blanking and re-rendering it.
 *
 * API-backed sections will mismatch, because the snapshot contains data the
 * client hasn't fetched yet on first render. React 18 recovers from that by
 * client-rendering the affected subtree, so the final UI is always correct;
 * the static chrome (header, footer, hero copy) still hydrates cleanly.
 *
 * Routes we don't prerender (and `npm start`) have an empty #root and take the
 * normal createRoot path.
 */
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
